import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import ColorOption from "containers/Customizer/ColorOption";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";

class App extends React.Component {
  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <Tour/> */}

        <Sidebar userMode="Admin" authUser={this.props.authUser} />
        <div className="app-main-container">
          <div
            className={`app-header ${
              navigationStyle === HORIZONTAL_NAVIGATION
                ? "app-header-horizontal"
                : ""
            }`}
          >
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                {/* Dashboard */}
                <Route
                  path={`${match.url}/dashboard`}
                  component={asyncComponent(() => import("./routes/dashboard"))}
                />
                {/* User Access */}
                <Route
                  path={`${match.url}/roles`}
                  component={asyncComponent(() =>
                    import("./routes/useraccess/roles")
                  )}
                />
                <Route
                  path={`${match.url}/AuditTrail`}
                  component={asyncComponent(() =>
                    import("./routes/useraccess/audits")
                  )}
                />
                <Route
                  path={`${match.url}/administrators`}
                  component={asyncComponent(() =>
                    import("./routes/useraccess/administrators")
                  )}
                />
                <Route
                  path={`${match.url}/studentAccess`}
                  component={asyncComponent(() =>
                    import("./routes/useraccess/studentAccess")
                  )}
                />
                {/* Administration */}
                <Route
                  path={`${match.url}/academicsession`}
                  component={asyncComponent(() =>
                    import("./routes/administration/sessions")
                  )}
                />
                <Route
                  path={`${match.url}/semesterRegistration`}
                  component={asyncComponent(() =>
                    import("./routes/administration/semesters")
                  )}
                />
                <Route
                  path={`${match.url}/schoolofficials`}
                  component={asyncComponent(() =>
                    import("./routes/administration/officials")
                  )}
                />
                <Route
                  path={`${match.url}/studentpayments`}
                  component={asyncComponent(() =>
                    import("./routes/administration/payments")
                  )}
                />
                <Route
                  path={`${match.url}/studentenquiry`}
                  component={asyncComponent(() =>
                    import("./routes/administration/students")
                  )}
                />
                <Route
                  path={`${match.url}/addnew`}
                  component={asyncComponent(() =>
                    import("./routes/administration/addNewStudent")
                  )}
                />
                <Route
                  path={`${match.url}/staff`}
                  component={asyncComponent(() =>
                    import("./routes/administration/staffs")
                  )}
                />
                <Route
                  path={`${match.url}/ProspectiveStudent`}
                  component={asyncComponent(() =>
                    import("./routes/administration/prospectiveStudents")
                  )}
                />
                {/* Setup */}
                <Route
                  path={`${match.url}/schoolinformation`}
                  component={asyncComponent(() =>
                    import("./routes/setup/information")
                  )}
                />
                <Route
                  path={`${match.url}/setupadmissionbatch`}
                  component={asyncComponent(() =>
                    import("./routes/setup/admissionBatch")
                  )}
                />
                <Route
                  path={`${match.url}/schoolsettings`}
                  component={asyncComponent(() =>
                    import("./routes/setup/settings")
                  )}
                />
                <Route
                  path={`${match.url}/semesters`}
                  component={asyncComponent(() =>
                    import("./routes/setup/semesters")
                  )}
                />
                <Route
                  path={`${match.url}/gradepoints`}
                  component={asyncComponent(() =>
                    import("./routes/setup/gradepoints")
                  )}
                />
                <Route
                  path={`${match.url}/levels`}
                  component={asyncComponent(() =>
                    import("./routes/setup/levels")
                  )}
                />
                <Route
                  path={`${match.url}/Classofdegrees`}
                  component={asyncComponent(() =>
                    import("./routes/setup/degree")
                  )}
                />
                <Route
                  path={`${match.url}/coregrades`}
                  component={asyncComponent(() =>
                    import("./routes/setup/scoregrades")
                  )}
                />
                <Route
                  path={`${match.url}/qualifications`}
                  component={asyncComponent(() =>
                    import("./routes/setup/qualifications")
                  )}
                />
                <Route
                  path={`${match.url}/grades`}
                  component={asyncComponent(() =>
                    import("./routes/setup/grades")
                  )}
                />
                <Route
                  path={`${match.url}/faculty`}
                  component={asyncComponent(() =>
                    import("./routes/setup/colleges")
                  )}
                />
                <Route
                  path={`${match.url}/Department`}
                  component={asyncComponent(() =>
                    import("./routes/setup/departments")
                  )}
                />
                {/* <Route
                  path={`${match.url}/departments`}
                  component={asyncComponent(() =>
                    import("./routes/setup/departments")
                  )}
                /> */}
                <Route
                  path={`${match.url}/schoolunits`}
                  component={asyncComponent(() =>
                    import("./routes/setup/schoolunits")
                  )}
                />
                <Route
                  path={`${match.url}/departmenttuition`}
                  component={asyncComponent(() =>
                    import("./routes/setup/departmenttuition")
                  )}
                />
                <Route
                  path={`${match.url}/matricnumberformat`}
                  component={asyncComponent(() =>
                    import("./routes/setup/matricnumber")
                  )}
                />
                <Route
                  path={`${match.url}/schoolpaymentsitem`}
                  component={asyncComponent(() =>
                    import("./routes/setup/payments")
                  )}
                />
                <Route
                  path={`${match.url}/paymentcategory`}
                  component={asyncComponent(() =>
                    import("./routes/setup/paymentcategory")
                  )}
                />
                <Route
                  path={`${match.url}/Courseofstudy`}
                  component={asyncComponent(() =>
                    import("./routes/setup/courseofstud")
                  )}
                />
                <Route
                  path={`${match.url}/setuppaymentitems`}
                  component={asyncComponent(() =>
                    import("./routes/setup/paymentitems")
                  )}
                />
                <Route
                  path={`${match.url}/scoreitems`}
                  component={asyncComponent(() =>
                    import("./routes/setup/scoreitems")
                  )}
                />
                <Route
                  path={`${match.url}/scoreitems/:id`}
                  component={asyncComponent(() =>
                    import("./routes/setup/scoreitems")
                  )}
                />
                <Route
                  path={`${match.url}/schoolgrades`}
                  component={asyncComponent(() =>
                    import("./routes/setup/schoolgrades")
                  )}
                />
                <Route
                  path={`${match.url}/itemschedule`}
                  component={asyncComponent(() =>
                    import("./routes/setup/itemSchedule")
                  )}
                />
                {/* Admission */}
                {/* <Route path={`${match.url}/admission/applicants`} component={asyncComponent(() => import('./routes/admission/applicants'))} /> */}
                <Route
                  path={`${match.url}/programmes`}
                  component={asyncComponent(() =>
                    import("./routes/setup/programme")
                  )}
                />
                <Route
                  path={`${match.url}/admission/admissionSession`}
                  component={asyncComponent(() =>
                    import("./routes/admission/admissionSession")
                  )}
                />
               
                <Route
                  path={`${match.url}/admissioninformation`}
                  component={asyncComponent(() =>
                    import("./routes/admission/information")
                  )}
                />
                <Route
                  path={`${match.url}/admissiondocument`}
                  component={asyncComponent(() =>
                    import("./routes/setup/documents")
                  )}
                />
                <Route
                  path={`${match.url}/timetable`}
                  component={asyncComponent(() =>
                    import("./routes/setup/timetable")
                  )}
                />
                <Route
                  path={`${match.url}/admissiondataentry`}
                  component={asyncComponent(() =>
                    import("./routes/admission/admdataentry")
                  )}
                />
                <Route
                  path={`${match.url}/admission/payments`}
                  component={asyncComponent(() =>
                    import("./routes/admission/payments")
                  )}
                />
                <Route
                  path={`${match.url}/admission/export`}
                  component={asyncComponent(() =>
                    import("./routes/admission/export")
                  )}
                />
                {/* Students */}
                {/* Staffs */}
                {/* <Route
                  path={`${match.url}/staffs/staffs`}
                  component={asyncComponent(() =>
                    import('./routes/staffs/staffs'),
                  )}
                /> */}
                {/* Admission Restructuring */}
                <Route
                  path={`${match.url}/ScreenAdmission`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/approved")
                  )}
                />
                <Route
                  path={`${match.url}/verifyadmission`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/verified")
                  )}
                />
                <Route
                  path={`${match.url}/confirmadmission`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/confirmed")
                  )}
                />
                <Route
                  path={`${match.url}/rejected`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/rejected")
                  )}
                />
                <Route
                  path={`${match.url}/UpdateAdmissionMode`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/updateEntryMode")
                  )}
                />
                <Route
                  path={`${match.url}/allapplications`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/allApplications")
                  )}
                />
                <Route
                  path={`${match.url}/CAPSList`}
                  component={asyncComponent(() =>
                    import("./routes/admission/CapList")
                  )}
                />
                <Route
                  path={`${match.url}/postUtmeList`}
                  component={asyncComponent(() =>
                    import("./routes/admission/postUtmeList/index")
                  )}
                />
                <Route
                  path={`${match.url}/uploadadmissionlist`}
                  component={asyncComponent(() =>
                    import("./routes/admission/UploadAdmission/index")
                  )}
                />
                <Route
                  path={`${match.url}/admissionlist`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/AdmissionList/index")
                  )}
                />
                <Route
                  path={`${match.url}/utmeImages`}
                  component={asyncComponent(() =>
                    import("./routes/admission/utmeImages")
                  )}
                />
                <Route
                  path={`${match.url}/screeningreport`}
                  component={asyncComponent(() =>
                    import("./routes/admissions/ScreeningReport")
                  )}
                />
                {/* Applications */}
                <Route
                  path={`${match.url}/inprogress`}
                  component={asyncComponent(() =>
                    import("./routes/application/inprogress")
                  )}
                />
                <Route
                  path={`${match.url}/completed`}
                  component={asyncComponent(() =>
                    import("./routes/application/completed")
                  )}
                />
                <Route
                  path={`${match.url}/learningdiscussion`}
                  component={asyncComponent(() =>
                    import("./routes/discussions")
                  )}
                />
                <Route
                  exact
                  path={`${match.url}/cbt`}
                  component={asyncComponent(() => import("./routes/cbt"))}
                />
                <Route
                  exact
                  path={`${match.url}/announcement`}
                  component={asyncComponent(() =>
                    import("./routes/announcements")
                  )}
                />
                {/* <Route
                  path={`${match.url}/application/rejected`}
                  component={asyncComponent(() =>
                    import('./routes/application/rejected'),
                  )}
                /> */}
                {/* Payments */}
                <Route
                  path={`${match.url}/PaymentHistory`}
                  component={asyncComponent(() =>
                    import("./routes/payments/PaymentHistory")
                  )}
                />
                <Route
                  path={`${match.url}/LiveClassroom`}
                  component={asyncComponent(() =>
                    import("./routes/online/liveclassroom")
                  )}
                />
                <Route
                  path={`${match.url}/managecontent`}
                  component={asyncComponent(() =>
                    import("./routes/online/lectureNotesUploads")
                  )}
                />
                payments/UpdatePaymentSession
                <Route
                  path={`${match.url}/UpdatePaymentSession`}
                  component={asyncComponent(() =>
                    import("./routes/payments/UpdatePaymentSession/index")
                  )}
                />
                {/* payme */}
                <Route
                  path={`${match.url}/revenue`}
                  component={asyncComponent(() =>
                    import("./routes/payments/revenue")
                  )}
                />
                <Route
                  path={`${match.url}/debtorslist`}
                  component={asyncComponent(() =>
                    import("./routes/payments/debtorsList")
                  )}
                />
                {/* Courses */}
                <Route
                  path={`${match.url}/SetupCourses`}
                  component={asyncComponent(() =>
                    import("./routes/courses/courses")
                  )}
                />
                {/* <Route
                  path={`${match.url}/CoreCourses`}
                  component={asyncComponent(() =>
                    import("./routes/courses/CoreCourses")
                  )}
                /> */}
                <Route
                  path={`${match.url}/PrerequisiteCourses`}
                  component={asyncComponent(() =>
                    import("./routes/courses/PrerequisiteCourses")
                  )}
                />
                <Route
                  path={`${match.url}/CourseLecturers`}
                  component={asyncComponent(() =>
                    import("./routes/courses/CourseLecturers")
                  )}
                />
                <Route
                  path={`${match.url}/CourseLecturers`}
                  component={asyncComponent(() =>
                    import("./routes/courses/courses")
                  )}
                />
                <Route
                  path={`${match.url}/ProgramRegistrationLImit`}
                  component={asyncComponent(() =>
                    import("./routes/courses/RegistrationLimit")
                  )}
                />
                <Route
                  path={`${match.url}/departmentcourses`}
                  component={asyncComponent(() =>
                    import("./routes/courses/DepartmentCourses")
                  )}
                />
                <Route
                  path={`${match.url}/RegisteredCourse`}
                  component={asyncComponent(() =>
                    import("./routes/courses/CourseRegistration")
                  )}
                />
                {/* <Route
                  path={`${match.url}/`}
                  component={asyncComponent(() =>
                    import("./routes/courses/StudentCourseList")
                  )}
                /> */}
                <Route
                  path={`${match.url}/studentforms`}
                  component={asyncComponent(() =>
                    import("./routes/setup/studentforms")
                  )}
                />
                <Route
                  path={`${match.url}/siwes`}
                  component={asyncComponent(() =>
                    import("./routes/Siwes/SiwesIndex/index")
                  )}
                />
                {/* <Route
                  path={`${match.url}/siwes`}
                  component={asyncComponent(() =>
                    import("./routes/Sheme/index.js")
                  )}
                /> */}
                <Route
                  path={`${match.url}/matriculation`}
                  component={asyncComponent(() =>
                    import("./routes/matricTable/index")
                  )}
                />
                {/* =========State  Module=========== */}
                <Route
                  path={`${match.url}/state`}
                  component={asyncComponent(() =>
                    import("./routes/setup/state")
                  )}
                />
                {/* =========Lga Module=========== */}
                <Route
                  path={`${match.url}/lga`}
                  component={asyncComponent(() => import("./routes/setup/lga"))}
                />
                <Route
                  path={`${match.url}/courses/uploadCourse`}
                  component={asyncComponent(() =>
                    import("./routes/courses/uploadCourse")
                  )}
                />
                <Route
                  path={`${match.url}/WAECVerify`}
                  component={asyncComponent(() =>
                    import("./routes/waecVerify")
                  )}
                />
                {/* <Route path={`${match.url}/manageCourseContent`} component={asyncComponent(() => import("./routes/courses/CourseContent"))} /> */}
                {/* Change Password */}
                <Route
                  path={`${match.url}/changepassword/`}
                  component={asyncComponent(() =>
                    import("./routes/changepassword")
                  )}
                />
                {/* Admin Profile */}
                <Route
                  path={`${match.url}/profile/`}
                  component={asyncComponent(() => import("./routes/profile"))}
                />
                {/* {Hostel Accommodation} */}
                <Route
                  path={`${match.url}/Hostels/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/setupHostel")
                  )}
                />
                <Route
                  path={`${match.url}/HostelAvailability/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/hostelAvailability")
                  )}
                />
                <Route
                  path={`${match.url}/HostelAllocation/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/hostelAllocation")
                  )}
                />
                <Route
                  path={`${match.url}/ReservedRooms/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/reservedRooms")
                  )}
                />
                <Route
                  path={`${match.url}/AllocateReservedRoom/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/AllocateReservedRoom")
                  )}
                />
                <Route
                  path={`${match.url}/Blocks/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/HostelBlock")
                  )}
                />
                <Route
                  path={`${match.url}/Campus/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/Campus")
                  )}
                />
                <Route
                  path={`${match.url}/Rooms/`}
                  component={asyncComponent(() =>
                    import("./routes/HostelAccomodation/Rooms")
                  )}
                />
                {/* Discussion */}
                <Route
                  path={`${match.url}/learningdiscussion/`}
                  component={asyncComponent(() =>
                    import("./routes/discussions")
                  )}
                />
                <Route
                  path={`${match.url}/studentdiscussion/`}
                  component={asyncComponent(() =>
                    import("./routes/discussions")
                  )}
                />
                <Route
                  path={`${match.url}/generaldiscussion/`}
                  component={asyncComponent(() =>
                    import("./routes/discussions")
                  )}
                />
                <Route
                  path={`${match.url}/discussiontypes/`}
                  component={asyncComponent(() =>
                    import("./routes/discussionTypes")
                  )}
                />
                {/* Grades */}
                <Route
                  path={`${match.url}/resultupload/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/ResultUpload")
                  )}
                />
                <Route
                  path={`${match.url}/viewResult/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/ViewResult")
                  )}
                />
                <Route
                  path={`${match.url}/ReviewResult/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/ReviewResult")
                  )}
                />
                <Route
                  path={`${match.url}/resultSheet/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/ResultSheet/")
                  )}
                />
                <Route
                  path={`${match.url}/publishresult/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/PublishResult")
                  )}
                />
                <Route
                  path={`${match.url}/ReviewSetup/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/ReviewSetup")
                  )}
                />
                <Route
                  path={`${match.url}/courseRegistration/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/CourseRegistration")
                  )}
                />
                <Route
                  path={`${match.url}/marksheet/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/MarkSheet")
                  )}
                />
                {/* <Route
                  path={`${match.url}/Transcript/`}
                  component={asyncComponent(() =>
                    import("./routes/grades/Transcript")
                  )}
                /> */}
                {/* summary of payment */}
                <Route
                  path={`${match.url}/SummaryofPayments/`}
                  component={asyncComponent(() =>
                    import("./routes/reports/paymentsummary")
                  )}
                />
                {/* end of payment */}
                {/* Transcript */}
                <Route
                  path={`${match.url}/transcriptRequest`}
                  component={asyncComponent(() =>
                    import("./routes/Transcript/dashboard")
                  )}
                  />
                <Route
                  path={`${match.url}/transcript`}
                  component={asyncComponent(() =>
                    import("./routes/grades/Transcript")
                  )}
                />
                <Route
                  path={`${match.url}/feeManagement`}
                  component={asyncComponent(() =>
                    import("./routes/Transcript/FeeManagement")
                  )}
                />
                <Route
                  path={`${match.url}/deliveryTracking`}
                  component={asyncComponent(() =>
                    import("./routes/Transcript/DeliveryTracking")
                  )}
                />
                <Route
                  path={`${match.url}/documentdelivery`}
                  component={asyncComponent(() =>
                    import("./routes/Transcript/DocumentDelivery")
                  )}
                />
                {/* =========Assignment Module===========*/}
                <Route
                  path={`${match.url}/assignment`}
                  component={asyncComponent(() =>
                    import("./routes/assignment")
                  )}
                />

                {/* =========E-Voting Module===========*/}
                 <Route
                                  path={`${match.url}/eresult`} 
                                  component={asyncComponent(() =>
                                    import("./routes/eVoting/accreditation_Voting")
                                  )}
                                />
                                <Route
                                  path={`${match.url}/setup`}
                                  component={asyncComponent(() =>
                                    import("./routes/eVoting/setUpVoting")
                                  )}
                                />
                {/* Error Page */}
                <Route
                  component={asyncComponent(() =>
                    import("app/routes/extraPages/routes/404")
                  )}
                />
              </Switch>
            </div>
            <Footer />
          </main>
        </div>
        <ColorOption />
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  const authUser = auth.adminUser;
  return { drawerType, navigationStyle, horizontalNavPosition, authUser };
};
export default withRouter(connect(mapStateToProps)(App));
